/**
 * What each numbered version of a programme is called on screen.
 *
 * Three counters share the words "revision" and "version": the save counter
 * behind optimistic concurrency, the governed curriculum revision an approval
 * produces, and a delivery variant of the programme. Each has one name here.
 *
 * @module components/shared/revision-labels
 */

/** The save counter a write is checked against. */
export function recordVersionLabel(saveRevision: number | string): string {
  return `Record version ${saveRevision}`;
}

/** A governed revision of the approved curriculum, e.g. `1.2`. */
export function curriculumRevisionLabel(revision: number | string): string {
  return `Curriculum revision ${revision}`;
}

/** A delivery variant of the programme, numbered from 1 by position. */
export function programmeVersionLabel(position: number): string {
  return `Programme version ${position}`;
}
